import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import {
    GetFilteredYards_getFilteredYards as Yard,
    GetAllRegions_getAllRegions_districts as DistrictType,
    GetAllRegions_getAllRegions as RegionType,
} from '../../types/schemaTypes';
import Modal from 'react-bootstrap/Modal';
import './Yards.scss';
import { CustomButton, Loading, Textfield } from '../_common';
import SearchableDropdown from '../_common/SearchableDropdown/SearchableDropdown';
import { ModalForm, Option } from './interface';
import { Col, Row } from 'react-bootstrap';
import { Circle, GoogleMap, LoadScript, Marker, Polygon } from '@react-google-maps/api';
import { geoFenceTypes } from '../_common/Geofence/GeofenceTypes';

interface LatLng {
    lat: number;
    lng: number;
}

let yardLat;
let yardLong;
let type;
let geofenceRadius;

interface AddEditYardModalProps {
    modalForm: ModalForm;
    options: Option[];
    stateOptions: Option[];
    regions: Option[];
    regionsWithDistricts: RegionType[];
    selectedYard?: Yard;
    onClickHide: () => void;
    saveLoading: boolean;
    onClickSave: (
        id: number,
        yardName: string,
        yardTypeId: number,
        lat: number,
        long: number,
        addressStreet: string,
        city: string,
        stateId: number,
        regionId: number,
        districtId: number,
        utm: string,
        zip: string,
        phoneNumber: string,
        directions: string,
        description: string,
        geoFenceType: string,
        geoFenceRadius: number,
        yardPolygonCoordinates: LatLng[],
    ) => void;
    show: boolean;
    errorMessage?: string;
}

const defaultGeoFenceRadius = 300;
const AddEditYardModal = ({
    show,
    options,
    stateOptions,
    regions,
    regionsWithDistricts,
    onClickSave,
    onClickHide,
    modalForm,
    selectedYard,
    errorMessage,
    saveLoading,
}: AddEditYardModalProps): React.ReactElement => {
    const [selectedId, setSelectedId] = useState(0);
    const [selectedYardName, setSelectedYardName] = useState('');
    const [selectedDesc, setSelectedDesc] = useState('');
    const [selectedAddr, setSelectedAddr] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedUtm, setSelectedUtm] = useState('');
    const [selectedDirections, setSelectedDirections] = useState('');
    const [selectedState, setSelectedState] = useState(0);
    const [selectedDistrictName, setSelectedDistrictName] = useState(0);
    const [selectedRegionName, setSelectedRegionName] = useState(0);
    const [selectedPhone, setSelectedPhone] = useState('');
    const [selectedZip, setSelectedZip] = useState('');
    const [selectedLong, setSelectedLong] = useState(0);
    const [selectedGeoFenceType, setSelectedGeoFenceType] = useState('Circle');
    const [selectedgeoFenceRadius, setSelectedgeoFenceRadius] = useState(300);
    const [selectedLat, setSelectedLat] = useState(0);
    const [selectedYardType, setSelectedYardType] = useState(0);
    const isEditForm = modalForm === ModalForm.EDIT_YARD;
    const [formErrors, setFormErrrors]: any = React.useState({});
    const [path, setPath] = useState<LatLng[]>([]);
    const [selectedyardPolygonCoordinates, setSelectedyardPolygonCoordinates] = useState<LatLng[]>([]);
    const [showRadius, setShowRadius] = useState(true);
    const [radius, setRadius] = useState(0);
    const [districts, setDistricts] = useState<Option[]>([]);

    useEffect(() => {

            setSelectedId(selectedYard?.id ? selectedYard.id : 0);
            setSelectedYardName(selectedYard?.yardName ? selectedYard.yardName : '');
            setSelectedYardType(selectedYard?.yardTypeId ? selectedYard.yardTypeId : 0);
            setSelectedLong(selectedYard?.longitude ? selectedYard.longitude : 0);
            setSelectedLat(selectedYard?.latitude ? selectedYard.latitude : 0);
            setSelectedGeoFenceType(selectedYard?.geoFenceType ? selectedYard.geoFenceType : 'Circle');
            setSelectedgeoFenceRadius(selectedYard?.geoFenceRadius ? selectedYard.geoFenceRadius : 300);
            setSelectedDesc(selectedYard?.description ? selectedYard.description : '');
            setSelectedState(selectedYard?.stateId ? selectedYard.stateId : 0);
            setSelectedRegionName(selectedYard?.regionId ? selectedYard.regionId : 0);
            setSelectedDistrictName(selectedYard?.districtId ? selectedYard.districtId : 0);
            setSelectedAddr(selectedYard?.addressStreet ? selectedYard.addressStreet : '');
            setSelectedCity(selectedYard?.city ? selectedYard.city : '');
            setSelectedUtm(selectedYard?.utm ? selectedYard.utm : '');
            setSelectedDirections(selectedYard?.directions ? selectedYard.directions : '');
            setSelectedPhone(selectedYard?.phoneNumber ? selectedYard.phoneNumber : '');
            setSelectedZip(selectedYard?.zip ? selectedYard.zip : '');
            if (selectedYard?.geoFenceType == 'Circle') {
                setShowRadius(true);
            } else {
                setShowRadius(false);
            }
            setPath([
                {
                    lat: selectedYard?.latitude ? selectedYard.latitude : yardLat,
                    lng: selectedYard?.longitude ? selectedYard.longitude : yardLong,
                },
                {
                    lat: selectedYard?.latitude ? selectedYard.latitude : yardLat,
                    lng: selectedYard?.longitude ? selectedYard.longitude : yardLong,
                },
            ]);
            const yardPolygonCoords: LatLng[] = [];
            if (
                selectedYard &&
                selectedYard.yardPolygonCoordinates &&
                selectedYard.yardPolygonCoordinates.length !== 0
            ) {
                selectedYard.yardPolygonCoordinates.forEach((element): void => {
                    if (element !== null) {
                        yardPolygonCoords.push({
                            lat: element.lat as number,
                            lng: element.lng as number,
                        });
                    }
                });
            }
            setSelectedyardPolygonCoordinates(yardPolygonCoords);

        setFormErrrors({});
    }, [selectedYard]);

    useEffect(() => {
        if (selectedRegionName) {
            setDistricts(getRegionDistricts(regionsWithDistricts, +selectedRegionName));
        }
    }, [selectedRegionName]);

    const getRegionDistricts = (regionsList: RegionType[], regionId: number | string): Option[] => {
        const selectedRegion = regionsList.filter((item: RegionType) => item.id === regionId)[0];
        const districtsList: Option[] = [];
        if (selectedRegion && selectedRegion.districts) {
            selectedRegion.districts.forEach((element: any) => {
                if (element && element.districtName !== null) {
                    districtsList.push({
                        id: element.id,
                        name: element.districtName,
                    });
                }
            });
        }

        return districtsList;
    };
    const polygonRefence = useRef<google.maps.Polygon | null>(null);
    const listenersReference = useRef<google.maps.MapsEventListener[]>([]);
    const circleRef = useRef<google.maps.Circle | null>(null);
    const changeName = (event: any): void => {
        formErrors.nameError = undefined;
        const name = event.target.value ? event.target.value : '';
        setSelectedYardName(name);
    };

    const changeYardType = (value: any): void => {
        const id = parseInt(value);
        setSelectedYardType(id);
    };

    const getYardName = (): string | number | null => {
        const id = selectedYard && selectedYard.yardTypeId ? selectedYard.yardTypeId.toString() : '';

        if (id == '') return null;

        const numId = parseInt(id);
        const filteredType = options.filter((item: Option) => item.id === numId);
        const yardType = filteredType[0].name;

        return yardType;
    };

    const onRegionChange = (regionId: any): void => {
        setDistricts(getRegionDistricts(regionsWithDistricts, +regionId));
        const selectedRegion = regionsWithDistricts.filter((item: RegionType) => item.id === +regionId)[0];
        if (selectedRegion) {
            setSelectedRegionName(selectedRegion.id);
            setSelectedDistrictName(0)
        }
    };

    const onDistrictChange = (districtId: any): void => {
        const numId = parseInt(districtId);
        if (districts.length > 0) {
            const selectedDistrict = districts.filter((item: any) => item.id === numId);
            type = selectedDistrict[0].id;
            setSelectedDistrictName(type);
        }
    };

    const changeDesc = (event: any): void => {
        const description = event.target.value ? event.target.value : '';

        setSelectedDesc(description);
    };

    const changeAddr = (event: any): void => {
        const address = event.target.value ? event.target.value : '';

        setSelectedAddr(address);
    };
    const changeCity = (event: any): void => {
        const city = event.target.value ? event.target.value : '';

        setSelectedCity(city);
    };
    const changeUtm = (event: any): void => {
        const utm = event.target.value ? event.target.value : '';

        setSelectedUtm(utm);
    };
    const changeZip = (event: any): void => {
        const zip = event.target.value ? event.target.value : '';

        setSelectedZip(zip);
    };

    const getStateName = (): string | number | null => {
        const id = selectedYard && selectedYard.stateId ? selectedYard.stateId.toString() : '';

        if (id == '') return null;

        const numId = parseInt(id);
        const filteredRole = stateOptions.filter((item: Option) => item.id === numId);
        const role = filteredRole[0].name;

        return role;
    };

    const changeState = (value: any): void => {
        const id = parseInt(value);
        setSelectedState(id);
    };

    const changePhone = (event: any): void => {
        const phone = event.target.value ? event.target.value : '';

        setSelectedPhone(phone);
    };

    const handleInputChange = (
        event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
    ): void => {
        event.persist();
        setSelectedDirections(event.target.value);
    };

    const changeLat = (event: any): void => {
        if (event.target.value) {
            const id = parseFloat(event.target.value);
            yardLat = id;
            setSelectedLat(id);
            setPath([
                {
                    lat: yardLat,
                    lng: yardLong,
                },
                {
                    lat: yardLat,
                    lng: yardLong,
                },
            ]);
        }
    };
    const changeLong = (event: any): void => {
        if (event.target.value) {
            const id = parseFloat(event.target.value);
            yardLong = id;
            setSelectedLong(id);
            setPath([
                {
                    lat: yardLat,
                    lng: yardLong,
                },
                {
                    lat: yardLat,
                    lng: yardLong,
                },
            ]);
        }
    };

    const changeRadius = (event: any): void => {
        if (event.target.value) {
            const radius = parseInt(event.target.value);
            geofenceRadius = radius;
            setSelectedgeoFenceRadius(radius);
        }
    };

    const onCircleDragEnd = (e) => {
        setSelectedLat(e.latLng.lat());
        setSelectedLong(e.latLng.lng());
    };

    const changedRadius = () => {
        if (circleRef.current) {
            const radius = circleRef.current.getRadius();
            setRadius(Math.round(radius));
            setSelectedgeoFenceRadius(Math.round(radius));
        }
    };
    const onCircleLoad = useCallback(
        (circle: google.maps.Circle) => {
            circleRef.current = circle;
        },
        [changedRadius, onCircleDragEnd],
    );

    const onEdit = useCallback(() => {
        if (polygonRefence.current) {
            const nextPath = polygonRefence.current
                .getPath()
                .getArray()
                .map((latLng: google.maps.LatLng) => {
                    return { lat: latLng.lat(), lng: latLng.lng() };
                });
            console.info(JSON.stringify(nextPath));
            setSelectedyardPolygonCoordinates(nextPath);
        }
    }, [setSelectedyardPolygonCoordinates]);

    const onLoad = useCallback(
        (polygon: google.maps.Polygon) => {
            polygonRefence.current = polygon;
            const path = polygon.getPath();
            if (path != undefined) {
                listenersReference.current.push(
                    path.addListener('set_at', onEdit),
                    path.addListener('insert_at', onEdit),
                    path.addListener('remove_at', onEdit),
                );
            }
        },
        [onEdit],
    );

    const onUnmount = useCallback(() => {
        listenersReference.current.forEach((lis) => lis.remove());
        polygonRefence.current = null;
    }, []);

    const changeGeoFenceType = (eventkey: any): void => {
        if (eventkey == '') return;

        const numId = parseInt(eventkey);
        const filteredType = geoFenceTypes.filter((item: Option) => item.id === numId);
        type = filteredType[0].name.toString();
        setSelectedGeoFenceType(type);
        setPath([
            {
                lat: selectedYard?.latitude ? selectedYard.latitude : yardLat,
                lng: selectedYard?.longitude ? selectedYard.longitude : yardLong,
            },
            {
                lat: selectedYard?.latitude ? selectedYard.latitude : yardLat,
                lng: selectedYard?.longitude ? selectedYard.longitude : yardLong,
            },
        ]);
        const yardPolygonCoords: LatLng[] = [];
        if (selectedYard && selectedYard.yardPolygonCoordinates && selectedYard.yardPolygonCoordinates.length !== 0) {
            selectedYard.yardPolygonCoordinates.forEach((element): void => {
                if (element !== null) {
                    yardPolygonCoords.push({
                        lat: element.lat as number,
                        lng: element.lng as number,
                    });
                }
            });
            setSelectedyardPolygonCoordinates(yardPolygonCoords);
        }
        if (type == 'Circle') {
            setShowRadius(true);
            geofenceRadius = 300;
            setSelectedgeoFenceRadius(300);
        } else {
            setShowRadius(false);
        }
    };

    const clearState = (): void => {
        setSelectedId(0);
        setSelectedYardName('');
        setSelectedYardType(0);
        setSelectedLat(0);
        setSelectedLong(0);
        setFormErrrors({});
        setSelectedGeoFenceType('Circle');
        setSelectedgeoFenceRadius(300);
        setSelectedDistrictName(0);
        setSelectedRegionName(0);
        setSelectedAddr('');
        setSelectedDesc('');
        setSelectedDirections('');
        setSelectedPhone('');
        setSelectedCity('');
        setSelectedyardPolygonCoordinates([]);
        setPath([]);
        setShowRadius(false);
        yardLat = '';
        yardLong = '';
        type = '';
        geofenceRadius = '';
    };

    const onSave = (): void => {
        onClickSave(
            selectedId,
            selectedYardName,
            selectedYardType,
            selectedLat,
            selectedLong,
            selectedAddr,
            selectedCity,
            selectedState,
            selectedRegionName,
            selectedDistrictName,
            selectedUtm,
            selectedZip,
            selectedPhone,
            selectedDirections,
            selectedDesc,
            selectedGeoFenceType,
            selectedgeoFenceRadius ? selectedgeoFenceRadius : defaultGeoFenceRadius,
            selectedyardPolygonCoordinates,
        );
        setSelectedDirections('');
        setFormErrrors({});
        yardLat = '';
        yardLong = '';

    };

    const onCancel = (): void => {
        clearState();
        onClickHide();
    };
    const validateDistrict:HTMLElement | null = document.getElementById('district')
    const validateForm = () => {
        const errors = {};

        if (!selectedYardName || (selectedYard !== undefined && !selectedYard.yardName)) {
            errors['yardName'] = 'Yard Name is required';
        }
        if (selectedCity == '' || (selectedYard !== undefined && selectedYard.city == '')) {
            errors['city'] = 'City is required';
        }
        if (selectedState == 0 || (selectedYard !== undefined && selectedYard.stateId == 0)) {
            errors['stateId'] = 'State is required';
        }
        if (selectedRegionName == 0 || (selectedYard !== undefined && selectedYard.regionId == 0)) {
            errors['regionId'] = 'Region is required';
        }
        if (validateDistrict?.innerHTML==='' ||selectedDistrictName == 0 || (selectedYard !== undefined && selectedYard.districtId == 0)) {
            errors['districtId'] = 'District is required';
        }
        if (!selectedYardType || (selectedYard !== undefined && !selectedYard.yardTypeId)) {
            errors['yardType'] = 'Yard Type is required';
        }
        if (selectedGeoFenceType == '' || selectedYard?.geoFenceType == '') {
            errors['geofenceType'] = 'GeoFence Type is required';
        }
        if (!selectedLat || (selectedYard !== undefined && !selectedYard.latitude)) {
            errors['Lat'] = 'Latitude is required';
        }
        if (!selectedLong || (selectedYard !== undefined && !selectedYard.longitude)) {
            errors['Long'] = 'Longitude is required';
        }
        if (selectedYard?.geoFenceType == 'Polygon' || type == 'Polygon') {
            if (selectedyardPolygonCoordinates.length < 2) {
                errors['polygonError'] = 'Please draw polyon on Map';
            }
        }
        return {
            isValid: Object.keys(errors).length === 0,
            errors,
        };
    };

    const handleSaveChanges = () => {
        setFormErrrors({});
        const { isValid, errors } = validateForm();

        if (!isValid) {
            setFormErrrors(errors);
            return;
        }
        onSave();
    };

    console.log("yd", selectedYard)
    const handleMarkerMove = (event) => {
        const lat: number = event.latLng.lat();
        const lng: number = event.latLng.lng();
        setSelectedLat(lat);
        setSelectedLong(lng);
    }
    return (
        <Modal show={show} onHide={onCancel} dialogClassName="AddEditYardModal">
            <Modal.Header className="AddEditYardModal-Header">
                <Modal.Title className="AddEditYardModal-Header-Container">
                    <button className="material-icons AddEditYardModal-X-Button" onClick={onCancel}>
                        close
                    </button>
                    <div className="AddEditYardModal-Title">{isEditForm ? 'Edit Yard' : 'Create New Yard'}</div>
                    <div className="AddEditYardModal-ErrorMessage">{errorMessage}</div>
                </Modal.Title>
            </Modal.Header>

            {saveLoading && (
                <div className="NoResult-Container">
                    <Loading />
                </div>
            )}

            <Row className="AddEditYardModal-Upper-TextField-Container">
                <Col className="AddEditYardModal-Textfield" md={6}>
                    <Textfield
                        label="Name"
                        required
                        value={selectedYard !== undefined ? selectedYard.yardName : ''}
                        onChange={(event): void => changeName(event)}
                        onBlur={() => { }}
                        error={formErrors.yardName}
                        helperText={formErrors.yardName}
                    />
                </Col>
                <Col className="AddEditYardModal-Down-TextField-Container" md={6}>
                    <SearchableDropdown
                        dropdownOptions={options}
                        id="yardtype"
                        label="Yard Type"
                        required
                        onSelect={(eventKey: string | null) => {
                            changeYardType(eventKey);
                        }}
                        value={getYardName()}
                        errorMessage={formErrors.yardType}
                        hasError={formErrors.yardType != undefined}
                    />
                </Col>
            </Row>

            <Row className="AddEditYardModal-Upper-TextField-Container">
                <Col className="AddEditYardModal-Textfield" md={6}>
                    <Textfield
                        label="Description"
                        value={selectedYard !== undefined ? selectedYard.description : ''}
                        onChange={(event): void => changeDesc(event)}
                        onBlur={() => { }}
                    />
                </Col>
                <Col className="AddEditYardModal-Textfield" md={6}>
                    <Textfield
                        label="AddressStreet"
                        value={selectedYard !== undefined ? selectedYard.addressStreet : ''}
                        onChange={(event): void => changeAddr(event)}
                        onBlur={() => { }}
                        error={formErrors.addressStreet}
                        helperText={formErrors.addressStreet}
                    />
                </Col>
            </Row>

            <Row className="AddEditYardModal-Upper-TextField-Container">
                <Col className="AddEditYardModal-Textfield" md={4}>
                    <Textfield
                        label="City"
                        required
                        value={selectedYard !== undefined ? selectedYard.city : ''}
                        onChange={(event): void => changeCity(event)}
                        onBlur={() => { }}
                        error={formErrors.city}
                        helperText={formErrors.city}
                    />
                </Col>
                <Col className="AddEditYardModal-Textfield" md={4}>
                    <Textfield
                        label="Zip"
                        value={selectedYard !== undefined ? selectedYard.zip : ''}
                        onChange={(event): void => changeZip(event)}
                        onBlur={() => { }}
                        error={formErrors.zip}
                        helperText={formErrors.zip}
                    />
                </Col>
                <Col className="AddEditYardModal-Down-TextField-Container" md={4}>
                    <SearchableDropdown
                        dropdownOptions={stateOptions}
                        id="state"
                        label="State"
                        required
                        onSelect={(eventKey: string | null) => {
                            changeState(eventKey);
                        }}
                        value={getStateName()}
                        errorMessage={formErrors.stateId}
                        hasError={formErrors.stateId != undefined}
                    />
                </Col>
            </Row>

            <Row className="AddEditYardModal-Upper-TextField-Container">
                <Col className="AddEditYardModal-Textfield" md={6}>
                    <Textfield
                        label="PhoneNumber"
                        value={selectedYard !== undefined ? selectedYard.phoneNumber : ''}
                        onChange={(event): void => changePhone(event)}
                        onBlur={() => { }}
                    />
                </Col>
                <Col className="AddEditYardModal-Textfield" md={6}>
                    <Textfield
                        label="Utm"
                        value={selectedYard !== undefined ? selectedYard.utm : ''}
                        onChange={(event): void => changeUtm(event)}
                        onBlur={() => { }}
                    />
                </Col>
            </Row>

            <Row className="AddEditYardModal-Upper-TextField-Container">
                <Col className="AddEditYardModal-Down-TextField-Container" md={6}>
                    <SearchableDropdown
                        dropdownOptions={regions}
                        id="region"
                        label="Region*"
                        onSelect={(eventKey: string | null) => {
                            onRegionChange(eventKey);
                        }}
                        value={
                            (selectedYard && selectedRegionName !== null)
                                ? regions.find((region) => region.id === selectedRegionName)?.name ?? ''
                                : ''
                        }
                        errorMessage={formErrors.regionId}
                        hasError={formErrors.regionId != undefined}
                    />
                </Col>
                <Col className="AddEditYardModal-Down-TextField-Container" md={6}>
                    <SearchableDropdown
                        dropdownOptions={districts}
                        id="district"
                        label="District*"
                        onSelect={(eventKey: string | null) => {
                            onDistrictChange(eventKey);
                        }}
                        value={
                            (selectedDistrictName !== null)
                                ? districts.find((district) => district.id === selectedDistrictName)?.name ?? ''
                                : ''
                        }
                        errorMessage={formErrors.districtId}
                        hasError={formErrors.districtId != undefined}
                    />
                </Col>
            </Row>

            <div className="AddEditYard-NotesContainer">
                <div className="AddEditYard-NotesLabel">DIRECTIONS</div>
                <textarea
                    className="AddEditYard-NotesParagraph"
                    name="directions"
                    rows={3}
                    value={selectedDirections}
                    onChange={(event) => {
                        handleInputChange(event);
                    }}
                />
            </div>

            <div className="AddEditYard-GeoFencingContainer">
                <div className="AddEditYard-NotesLabel">Geofencing</div>
                <Row>
                    <Col md={5} className="AddEditYardModal-Upper-TextField-Container">
                            <Textfield
                                id="Lat"
                                label="Latitude"
                                required
                                value={selectedLat}
                                onChange={(event): void => changeLat(event)}
                                error={formErrors.Lat}
                                helperText={formErrors.Lat}
                            />
                            <Textfield
                                id="Long"
                                label="Longitude"
                                required
                                value={selectedLong}
                                onChange={(event): void => changeLong(event)}
                                error={formErrors.Long}
                                helperText={formErrors.Long}
                            />
                        <div className="AddEditYardModal-Down-TextField-Container-Sm">
                            <SearchableDropdown
                                dropdownOptions={geoFenceTypes}
                                id="geofenceType"
                                label="Geofence Type"
                                onSelect={(eventKey: string | null) => {
                                    changeGeoFenceType(eventKey);
                                }}
                                value={selectedYard !== undefined ? selectedYard.geoFenceType : selectedGeoFenceType}
                                errorMessage={formErrors.geofenceType}
                                hasError={formErrors.geofenceType != undefined}
                                required
                            />
                        </div>
                            {(showRadius || selectedGeoFenceType == 'Circle') && (
                                <Textfield
                                    label="Radius (Meters)"
                                    value={selectedgeoFenceRadius}
                                    onChange={(event): void => changeRadius(event)}
                                    onBlur={() => { }}
                                    error={formErrors.Radius}
                                    helperText={formErrors.Radius}
                                    required
                                />
                            )}
                    </Col>
                    <Col md={7}>
                        <div className="GeoFenceMap-Container-Yard">
                            <LoadScript googleMapsApiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY || ''}>
                                {/* <LoadScript googleMapsApiKey=""> */}
                                <GoogleMap
                                    mapContainerClassName="GeoFence-Map-Yard"
                                    center={{
                                        lat: selectedYard?.latitude ? selectedYard.latitude : yardLat,
                                        lng: selectedYard?.longitude ? selectedYard.longitude : yardLong,
                                    }}
                                    zoom={16}
                                    mapTypeId="satellite"
                                >
                                    <Polygon
                                        editable
                                        draggable
                                        path={path}
                                        paths={selectedyardPolygonCoordinates}
                                        onMouseUp={onEdit}
                                        onDragEnd={onEdit}
                                        onLoad={onLoad}
                                        onUnmount={onUnmount}
                                        options={{
                                            fillColor: '#009dc7',
                                            strokeColor: '#009dc7',
                                            strokeOpacity: 0.7,
                                            fillOpacity: 0.3,
                                            strokeWeight: 2,
                                        }}
                                        visible={selectedGeoFenceType !== 'Circle'}
                                    />
                                    <Fragment>
                                        <Marker
                                            draggable
                                            onDragEnd={handleMarkerMove}
                                            position={{
                                                lat: parseFloat(
                                                    selectedLat
                                                        ? selectedLat
                                                        : selectedYard?.latitude
                                                            ? selectedYard.latitude
                                                            : yardLat,
                                                ),
                                                lng: parseFloat(
                                                    selectedLong
                                                        ? selectedLong
                                                        : selectedYard?.longitude
                                                            ? selectedYard.longitude
                                                            : yardLong,
                                                ),
                                            }}
                                        />
                                        <Circle
                                            draggable
                                            editable
                                            onDragEnd={(e) => onCircleDragEnd(e)}
                                            onLoad={onCircleLoad}
                                            onRadiusChanged={() => {
                                                changedRadius();
                                            }}
                                            center={{
                                                lat: parseFloat(
                                                    selectedLat
                                                        ? selectedLat
                                                        : selectedYard?.latitude
                                                            ? selectedYard.latitude
                                                            : yardLat,
                                                ),
                                                lng: parseFloat(
                                                    selectedLong
                                                        ? selectedLong
                                                        : selectedYard?.longitude
                                                            ? selectedYard.longitude
                                                            : yardLong,
                                                ),
                                            }}
                                            radius={
                                                geofenceRadius
                                                    ? geofenceRadius
                                                    : selectedYard?.geoFenceRadius
                                                        ? selectedYard.geoFenceRadius
                                                        : defaultGeoFenceRadius
                                            }
                                            options={{
                                                fillColor: '#009dc7',
                                                strokeColor: '#009dc7',
                                                strokeOpacity: 0.7,
                                                fillOpacity: 0.3,
                                                strokeWeight: 1,
                                            }}
                                            visible={selectedGeoFenceType !== 'Polygon'}
                                        />
                                    </Fragment>
                                </GoogleMap>q
                            </LoadScript>
                        </div>
                        <span className="Polygon-Error">{formErrors.polygonError}</span>
                    </Col>
                </Row>
            </div>

            <Modal.Footer className="AddEditYardModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onCancel}></CustomButton>
                <CustomButton
                    title="Save"
                    // isDisabled={setSaveButtonStatus()}
                    onClick={handleSaveChanges}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default AddEditYardModal;

